import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

function loadShortcodes() {
   
  let shortCodesToLoad = document.getElementsByClassName( 'staedte-shortcode-react-nodes' );

  let shortcodes = {
    length: 0
  };
  for( let i=0; i<shortCodesToLoad.length; i++ ) {

    let currentShortcodeNode = shortCodesToLoad.item(i);
    let currentComponent = currentShortcodeNode.getAttribute('staedte-react-component');

    if ( currentComponent && !shortcodes[currentComponent] ) {
      shortcodes[currentComponent] = true;
      shortcodes.length += 1;
    }

  }

  if ( 0 < shortcodes.length && !window.staedteFrontendShortcodeData.data_preloaded ) {

    delete(shortcodes.length);

    let requestBody = {
      shortcodes: Object.keys( shortcodes ),
      event: window.staedteFrontendShortcodeData.event
    }
    
    // Parses the current URL parameters
    if ( window.location.search ) {

      let params = window.location.search.substring(1);
      params.split('&').forEach(
        pair => {
          let keyValuePair = pair.split('=');
          requestBody[keyValuePair[0]] = decodeURIComponent(keyValuePair[1]);
        }
      );

    }

    fetch(
      `${window.staedteFrontendShortcodeData.masterDomain}/wp-json/staedte_rest/v1/frontend/shortcodes/data`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      }
    ).then(
      fulfilled => {

        if ( fulfilled.ok ) {
          return fulfilled.json();
        }

        // TODO: Handle error reponse

      },
      rejected => {

        // TODO: Handle rejected promise
        console.error(rejected);

      }
    ).then(
      rspData => {
        
        window.staedteFrontendShortcodeData.preloaded_data = rspData;

        renderShortcodes( shortCodesToLoad );
        

      }
    )

  } else {
    renderShortcodes( shortCodesToLoad );
  }

}

function renderShortcodes(shortcodes) {

  for( let i=0; i<shortcodes.length; i++ ) {

    let currentDomNode = shortcodes.item(i);
    let currentRoot = ReactDOM.createRoot( currentDomNode );
    let currentShortcode = currentDomNode.getAttribute('staedte-react-component');

    currentRoot.render(
      <React.StrictMode>
        <App shortcode={currentShortcode} data={window.staedteFrontendShortcodeData.preloaded_data[currentShortcode]} />
      </React.StrictMode>
    );

  }

}

window.addEventListener(
  'load',
  loadShortcodes
);
/*
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
